import Shoutbox from './Shoutbox.container';

export default Shoutbox;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/sections/shoutbox/index.js